import { SmallDetailsStatus } from '@midocean/webapps-shared-domain';

export type SmallDetailsResult = {
  positiveDetailsLoss: number;
  negativeDetailsLoss: number;
  pngFile: string;
  calculatedQuality: number;
  id: string;
};

export type SmallDetailsPayload = SmallDetailsResult & {
  status: SmallDetailsStatus;
  approvedAt: string | undefined;
  pngFileBlob: Blob;
  isCheckValid: boolean;
};

export type CheckImageSmallDetailsCommand = {
  id: string;
  logoWidthInMm: number;
  positiveLimitInMm: number;
  negativeLimitInMm: number;
  ignoreColors: boolean;
};

export type ProcessTextCommand = {
  id: string;
  font: string;
  fontSize: number;
  isBold: boolean;
  isItalic: boolean;  
  text: string;
  textColor: string;
  textAlignment: TextAlignment;
};

export type TextAlignment = 'Left' | 'Center' | 'Right';

export const DefaultSmallDetailsResult: SmallDetailsPayload = {
  isCheckValid: false,
  positiveDetailsLoss: 0,
  negativeDetailsLoss: 0,
  pngFile: '',
  calculatedQuality: 0,
  id: '',
  status: 'Good',
  approvedAt: undefined,
  pngFileBlob: new Blob(),
};
